import { SignupFlow } from "../components/SignUpFlow"
export function SignUp(){

    return(
    <div className="min-h-screenbg-white/90 flex flex-col items-center justify-center md:p-0 ">

        <SignupFlow />

    </div> )   

}